import React, { useState } from 'react';
import { Box, Typography, Button, Card, CardContent, CardMedia, Menu, MenuItem, ListItemIcon, ListItemText, Chip, Grid } from '@mui/material';
import { KeyboardArrowDown, ShoppingCart, Computer, MenuBook, Favorite, AutoAwesome } from '@mui/icons-material';
import { info } from '../../info/Info';
import macomlivro from '../../img/bookPhotoMaria2.png';
import { trackProductClick, trackBookMenuOpen, trackBookPurchaseClick } from '../../analytics';

export default function Livro({ darkMode }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        trackBookMenuOpen(); // Track when user opens the purchase menu
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlePurchaseOption = (url, platform, format, country) => {
        // Track the specific purchase button clicked
        trackBookPurchaseClick(platform, format, country);

        // Also track with the old method for backwards compatibility
        const fullPlatformName = `${platform} - ${format}${country ? ' ' + country : ''}`;
        trackProductClick(fullPlatformName);

        window.open(url, '_blank', 'noopener noreferrer');
        handleClose();
    };

    const handleDirectPurchase = (url, productName) => {
        trackProductClick(productName);
        window.open(url, '_blank', 'noopener noreferrer');
    };
    return (
        <Box component={'main'} display={'flex'} flexDirection={'column'} alignItems={'center'}
            justifyContent={'center'} minHeight={'calc(100vh - 175px)'} py={4}>

            <Box display={'flex'} flexDirection={'column'} alignItems={'center'} maxWidth={'1050px'} px={3} width={'100%'}>
                <Typography variant="h2" component="h1" textAlign="center" mb={3}
                    sx={{ fontSize: { xs: '2rem', md: '3rem' }, fontWeight: 'bold' }}>
                    Guia prático de Autocuidado
                </Typography>

                <Typography variant="h5" component="h2" textAlign="center" mb={4}
                    sx={{ fontSize: { xs: '1.2rem', md: '1.5rem' }, opacity: 0.8 }}>
                    Transforme sua casa em um espaço de cura e bem-estar
                </Typography>

                <Card sx={{
                    width: '100%',
                    maxWidth: 1000,
                    boxShadow: 3,
                    borderRadius: 2
                }}>
                    <Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} sx={{ height: '100%' }}>
                        <CardMedia
                            component="img"
                            image={macomlivro}
                            alt="Maria com o livro Guia prático de Autocuidado"
                            sx={{
                                width: { xs: '100%', md: 350 },
                                height: { xs: 320, md: 'auto' },
                                objectFit: 'cover',
                                objectPosition: { xs: 'center center', md: 'center 20%' },
                                borderRadius: { xs: '8px 8px 0 0', md: '8px 0 0 8px' },
                                flexShrink: 0,
                                display: 'block'
                            }}
                        />

                        <CardContent sx={{ flex: 1, p: { xs: 3, md: 3.5 }, width: '100%' }}>
                            <Typography variant="h4" component="h3" gutterBottom
                                sx={{ fontSize: { xs: '1.5rem', md: '1.8rem' } }}>
                                Sobre o Livro
                            </Typography>

                            <Typography variant="body1" paragraph sx={{ fontSize: '1rem', lineHeight: 1.6 }}>
                                Oie! Acabei de lançar meu workbook terapêutico para mães — um guia prático, cheio de exercícios
                                que uso dentro da minha metodologia clínica, pensado exatamente para mulheres que se sentem
                                sobrecarregadas, cansadas e sem tempo para cuidar de si. 💜
                            </Typography>

                            <Typography variant="body1" paragraph sx={{ fontSize: '1rem', lineHeight: 1.6 }}>
                                Reuni todos os exercícios e reflexões que deram resultados às minhas pacientes e transformei
                                nesse guia. Para quem não pode ou não consegue investir no processo terapêutico agora,
                                ele é uma ótima opção para começar a se trabalhar em casa — equivale a 30 sessões de terapia.
                            </Typography>

                            <Typography variant="body1" paragraph sx={{ fontSize: '1rem', lineHeight: 1.6 }}>
                                Em vez de um investimento alto em consultas, você tem acesso a esse conteúdo por um valor
                                bem menor e ainda pode usar no seu ritmo, de acordo com sua rotina de mãe:
                            </Typography>

                            {/* Seção de opções de compra */}
                            <Typography variant="h5" component="h3" gutterBottom textAlign="center" mt={3} mb={2.5}
                                sx={{ fontSize: { xs: '1.3rem', md: '1.6rem' }, fontWeight: 'bold' }}>
                                Escolha sua opção:
                            </Typography>

                            {/* Purchase Options Grid */}
                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                {/* Livro Físico */}
                                <Grid item xs={12} md={4}>
                                    <Card sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        position: 'relative',
                                        border: '2px solid',
                                        borderColor: 'divider',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-5px)',
                                            boxShadow: 6,
                                            borderColor: info.baseColor
                                        }
                                    }}>
                                        <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 2, display: 'flex', flexDirection: 'column' }}>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <MenuBook sx={{ fontSize: 40, color: info.baseColor, mb: 1 }} />
                                                <Typography variant="h6" component="h4" gutterBottom fontWeight="bold" sx={{ fontSize: '1rem' }}>
                                                    Livro Físico
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" paragraph sx={{ fontSize: '0.85rem', mb: 1 }}>
                                                    Tenha o guia impresso em mãos para trabalhar no seu ritmo
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontSize: '0.8rem' }}>
                                                    • Formato físico<br />
                                                    • Disponível em 3 países<br />
                                                    • Entrega pelos correios
                                                </Typography>
                                            </Box>
                                            <Button
                                                variant="outlined"
                                                fullWidth
                                                onClick={handleClick}
                                                endIcon={<KeyboardArrowDown />}
                                                sx={{
                                                    borderColor: info.baseColor,
                                                    color: info.baseColor,
                                                    fontWeight: 'bold',
                                                    '&:hover': {
                                                        borderColor: info.accent,
                                                        backgroundColor: `${info.baseColor}10`
                                                    }
                                                }}
                                            >
                                                Ver opções
                                            </Button>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Pacote Premium - DESTAQUE */}
                                <Grid item xs={12} md={4}>
                                    <Card sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        position: 'relative',
                                        border: '2px solid',
                                        borderColor: 'divider',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-5px)',
                                            boxShadow: 6,
                                            borderColor: info.baseColor
                                        }
                                    }}>
                                        <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 2, display: 'flex', flexDirection: 'column' }}>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Favorite sx={{ fontSize: 40, color: info.accent, mb: 1 }} />
                                                <Typography variant="h6" component="h4" gutterBottom fontWeight="bold" sx={{ fontSize: '1rem' }}>
                                                    Pacote de Autocuidado
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" paragraph fontWeight="medium" sx={{ fontSize: '0.85rem', mb: 1 }}>
                                                    Livro Digital + Sessão Individual
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontSize: '0.8rem' }}>
                                                {/* • Livro digital <br /> */}
                                                {/* • 1 sessão de autocuidado<br /> */}
                                                {/* • Acolhimento personalizado.<br /> */}
                                                • Acesso ao e-book guia prático.<br />
                                                • Sessão individual para definirmos juntas o seu plano de autocuidado.
                                            </Typography>
                                            </Box>
                                            {/* <Box sx={{ mb: 1.5, p: 1.5, bgcolor: 'background.paper', borderRadius: 2 }}>
                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', fontStyle: 'italic', lineHeight: 1.3 }}>
                                                    "Te pego pela mão e te ensino, passo a passo, como explorar o livro para sair do modo sobrevivência"
                                                </Typography>
                                            </Box> */}
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                onClick={() => handleDirectPurchase(
                                                    'https://go.hotmart.com/O103695914S?dp=1',
                                                    'Pacote Livro + Sessão'
                                                )}
                                                sx={{
                                                    background: `linear-gradient(45deg, ${info.baseColor} 30%, ${info.accent} 90%)`,
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    py: 1,
                                                    fontSize: '0.85rem',
                                                    '&:hover': {
                                                        background: `linear-gradient(45deg, ${info.accent} 30%, ${info.baseColor} 90%)`,
                                                        boxShadow: 6
                                                    }
                                                }}
                                            >
                                                Quero esse pacote 💜
                                            </Button>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Livro Digital */}
                                <Grid item xs={12} md={4}>
                                    <Card sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        position: 'relative',
                                        border: '2px solid',
                                        borderColor: 'divider',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-5px)',
                                            boxShadow: 6,
                                            borderColor: info.baseColor
                                        }
                                    }}>
                                        <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 2, display: 'flex', flexDirection: 'column' }}>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Computer sx={{ fontSize: 40, color: info.baseColor, mb: 1 }} />
                                                <Typography variant="h6" component="h4" gutterBottom fontWeight="bold" sx={{ fontSize: '1rem' }}>
                                                    Livro Digital
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" paragraph sx={{ fontSize: '0.85rem', mb: 1 }}>
                                                    Acesso imediato ao guia em formato digital
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontSize: '0.8rem' }}>
                                                    • PDF interativo<br />
                                                    • Acesso vitalício<br />
                                                    • Disponível imediatamente
                                                </Typography>
                                            </Box>
                                            <Button
                                                variant="outlined"
                                                fullWidth
                                                onClick={() => handleDirectPurchase(
                                                    'https://go.hotmart.com/R102152963B?dp=1',
                                                    'Livro Digital'
                                                )}
                                                sx={{
                                                    borderColor: info.baseColor,
                                                    color: info.baseColor,
                                                    fontWeight: 'bold',
                                                    '&:hover': {
                                                        borderColor: info.accent,
                                                        backgroundColor: `${info.baseColor}10`
                                                    }
                                                }}
                                            >
                                                Comprar agora
                                            </Button>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            <Typography variant="body2" textAlign="center" mt={2} sx={{ opacity: 0.7, fontSize: '0.9rem' }}>
                                💳 Pagamento seguro via Hotmart • 📧 Acesso imediato por e-mail
                            </Typography>
                        </CardContent>
                    </Box>
                </Card>

            {/* Menu de opções físicas */}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                sx={{
                    '& .MuiPaper-root': {
                        minWidth: 250,
                        borderRadius: 2,
                        boxShadow: 3
                    }
                }}
            >
                                    <MenuItem
                                        onClick={() => handlePurchaseOption(
                                            'https://loja.uiclap.com/titulo/ua120571/',
                                            'UiClap',
                                            'Livro Físico',
                                            'Brasil'
                                        )}
                                        sx={{ py: 1.5 }}
                                    >
                                        <ListItemIcon>
                                            <MenuBook sx={{ color: info.baseColor }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Livro Físico 🇧🇷"
                                            secondary="UiClap (Brasil)"
                                            primaryTypographyProps={{ fontWeight: 'bold' }}
                                        />
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() => handlePurchaseOption(
                                            'https://www.amazon.com/dp/B0FS79JPBC?ref_=pe_93986420_774957520',
                                            'Amazon',
                                            'Livro Físico',
                                            'EUA'
                                        )}
                                        sx={{ py: 1.5 }}
                                    >
                                        <ListItemIcon>
                                            <ShoppingCart sx={{ color: info.baseColor }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Amazon 🇺🇸"
                                            secondary="Livro Físico para quem reside nos EUA"
                                            primaryTypographyProps={{ fontWeight: 'bold' }}
                                        />
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() => handlePurchaseOption(
                                            'https://www.amazon.es/-/pt/dp/B0FS79JPBC/ref=tmm_pap_swatch_0?_encoding=UTF8&dib_tag=se&dib=eyJ2IjoiMSJ9.hgxw1xiRNAx5lqNr9cZC4IyufjybzpKbJXGWbpWnBvxVEXPapRZGIE3RAYIYMLlGpOO77ekDV7DvMDxLgEt8VWBSm6ooHODbyqDANgm7auEydM_JA9LQtlkwnbt_p_GEsRERPb7U8JIEsi1n5rtnNA.JoIBXN8AAM0c3aqtR_4jz1yu1xdZb3oNGWNTMYni2ew&qid=1761096304&sr=8-1',
                                            'Amazon',
                                            'Livro Físico',
                                            'Portugal'
                                        )}
                                        sx={{ py: 1.5 }}
                                    >
                                        <ListItemIcon>
                                            <ShoppingCart sx={{ color: info.baseColor }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Amazon 🇵🇹"
                                            secondary="Livro Físico para quem reside em Portugal"
                                            primaryTypographyProps={{ fontWeight: 'bold' }}
                                        />
                                    </MenuItem>

                                </Menu>

                {/* <Box mt={4} textAlign="center">
                        <Typography variant="h5" component="h3" gutterBottom
                                    sx={{ fontSize: { xs: '1.3rem', md: '1.8rem' } }}>
                            Um investimento no seu bem-estar
                        </Typography>
                        
                        <Typography variant="body1" sx={{ 
                            fontSize: '1.1rem', 
                            maxWidth: '600px', 
                            margin: '0 auto',
                            lineHeight: 1.6,
                            opacity: 0.9
                        }}>
                            Mais que um livro, é um guia prático para uma vida mais equilibrada e harmoniosa. 
                            Comece hoje mesmo sua jornada de transformação pessoal.
                        </Typography>
                    </Box> */}
            </Box>
        </Box>
    );
}